export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7581.5de3aa50.jpg";